<template>
    <LayoutMain>
        <template slot="body">
            <p class="page_section__title t-h--2 has-text-centered"> {{$t('POLÍTICA DE PRIVACIDADE')}}</p>
            <br>
            <p>
              {{$t('A CONSTÁLICA - ELEMENTOS CONSTRUÇÃO METÁLICA, S.A. (adiante, CONSTÁLICA), com sede na Zona Industrial Monte Cavalo, Lt 25, 3670 -273 Vouzela e NIPC 506927563 é a proprietária do domínio www.constalica.com, onde se encontra alojado o seu WEBSITE.')}}
            </p>
            <br>
            <p>
              {{$t('A CONSTÁLICA, ENQUANTO RESPONSÁVEL PELO TRATAMENTO DE DADOS, ESTÁ EMPENHADA EM PROTEGER A PRIVACIDADE E OS DADOS PESSOAIS DOS SEUS CLIENTES E UTILIZADORES DO WEBSITE, PELO QUE, ELABOROU E ADOTOU A PRESENTE POLÍTICA E AS PRÁTICAS AQUI DESCRITAS.')}}
            </p>
            <p>
              {{$t('ESTA POLÍTICA DE PRIVACIDADE EXPLICA COMO SÃO RECOLHIDOS E TRATADOS OS SEUS DADOS PESSOAIS, PELO QUE, ACONSELHAMOS A SUA LEITURA PARA CONHECER AS CONDIÇÕES EM QUE OS SEUS DADOS PESSOAIS SÃO RECOLHIDOS E UTILIZADOS.')}}
            </p>
            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('DO QUE TRATA ESTA POLÍTICA?')}}
              </p>
            </div>
            <p>
              {{$t('Esta Política de Privacidade explica como recolhemos e tratamos os dados pessoais que são necessários para o fornecimento de serviços que estão disponíveis através do WEBSITE, descrevendo as práticas adotadas para esse efeito.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('O QUE SÃO DADOS PESSOAIS?')}}
              </p>
            </div>

            <p>
              {{$t('Dados pessoais são todas as informações relativas a uma pessoa e que a identificam, ou a tornam identificável, independentemente da natureza e suporte das informações, incluindo o som e a imagem da pessoa.')}}
            </p>
            <p>
              {{$t('Exemplos de dados pessoais que recolhemos são o seu nome e e-mail quando se regista no WEBSITE.')}}
            </p>
            <p>
              {{$t('Por identificável, deve entender-se uma pessoa que possa ser identificada, direta ou indiretamente, designadamente por referência a um número de identificação ou a outros elementos específicos da sua identidade física, fisiológica, psíquica, económica, cultural ou social.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('COMO VAMOS UTILIZAR OS SEUS DADOS PESSOAIS?')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA irá utilizar os dados pessoais que nos forneça para as seguintes finalidades:')}}
            </p>
            <ol type="a">
              <li>{{$t('Para seleção e recrutamento;')}}</li>
              <li>{{$t('Para analisar e responder às suas mensagens, apoio ao cliente e pedidos de informação;')}}</li>
              <li>{{$t('Para manter um registo dos seus detalhes de contacto;')}}</li>
              <li>{{$t('Para criar a sua conta de utilizador no WEBSITE e permitir a fruição das funcionalidades da mesma;')}}</li>
              <li>{{$t('Para manter o seu registo e dados de utilizador na área reservada;')}}</li>
              <li>{{$t('Para as operações de gestão do WEBSITE;')}}</li>
              <li>{{$t('Para fins comerciais, como análise de dados, auditorias;')}}</li>
              <li>{{$t('Para prevenção de fraudes e segurança dos sistemas de informação;')}}</li>
              <li>{{$t('Para a adaptação, melhoria e modificação dos serviços, nomeadamente, através da identificação de tendências de utilização, ou, para determinar a eficácia das campanhas promocionais.')}}</li>
            </ol>
            <p>
              {{$t('Estas operações de tratamento de dados pessoais são uma ferramenta essencial para a sua satisfação e para a atividade da CONSTÁLICA e são realizadas de acordo com a legislação aplicável e conforme as melhores práticas.')}}
            </p>
            <p>
              {{$t('Os seus dados pessoais não serão reutilizados para outras finalidades que não sejam previamente identificadas ou que não tenham qualquer relação com aquelas finalidades para as quais foram inicialmente recolhidos.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('QUAIS OS FUNDAMENTOS PARA TRATARMOS OS DADOS PESSOAIS QUE RECOLHEMOS?')}}
              </p>
            </div>

            <p>
              {{$t('Os dados pessoais que a CONSTÁLICA trata têm fundamentos específicos, consoante as finalidades a que se destinam.')}}
            </p>
            <p>
              {{$t('Na tabela seguinte pode visualizar quais os fundamentos consoantes as finalidades acima identificadas:')}}
            </p>

            <table class="table">
              <thead>
                  <tr>
                      <th>{{$t('FINALIDADE')}}</th>
                      <th>{{$t('FUNDAMENTO')}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>{{$t('Para seleção e recrutamento;')}}</td>
                      <td>{{$t('Diligências pré-contratuais.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para analisar e responder às suas mensagens, apoio ao cliente e pedidos de informação.')}}</td>
                      <td>{{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para manter um registo dos seus detalhes de contacto.')}}</td>
                      <td>{{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para criar a sua conta de utilizador no WEBSITE e permitir a fruição das funcionalidades da mesma.')}}</td>
                      <td>{{$t('Execução do contrato.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para manter o seu registo e dados de utilizador na área reservada.')}}</td>
                      <td>{{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para as operações de gestão do WEBSITE.')}}</td>
                      <td>{{$t('Consentimento para essa finalidade específica (cookies);')}} <br> {{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para fins comerciais, como análise de dados, auditorias.')}}</td>
                      <td>{{$t('Consentimento para essa finalidade específica (cookies);')}} <br> {{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para prevenção de fraudes e segurança dos sistemas de informação.')}}</td>
                      <td>{{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para a adaptação, melhoria e modificação dos serviços, nomeadamente, através da identificação de tendências de utilização, ou, para determinar a eficácia das campanhas promocionais.')}}</td>
                      <td>{{$t('Consentimento para essa finalidade específica (cookies);')}} <br> {{$t('Interesses legítimos prosseguidos pela CONSTÁLICA.')}}</td>
                  </tr>
              </tbody>
            </table>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('QUE DADOS PESSOAIS RECOLHEMOS?')}}
              </p>
            </div>

            <p>
              {{$t('Os dados pessoais que a CONSTÁLICA recolhe e trata são apenas aqueles necessários e adequados às finalidades acima indicadas.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA irá recolher e tratar os seguintes dados pessoais:')}}
            </p>

            <table class="table">
              <thead>
                  <tr>
                      <th>{{$t('FINALIDADE')}}</th>
                      <th>{{$t('DADOS')}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>{{$t('Para seleção e recrutamento;')}}</td>
                      <td>{{$t('Nome, email, telefone e CV.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para analisar e responder às suas mensagens, apoio ao cliente e pedidos de informação.')}}</td>
                      <td>{{$t('Nome, email, cargo e empresa.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para manter um registo dos seus detalhes de contacto.')}}</td>
                      <td>{{$t('Nome, email e telefone.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para criar a sua conta de utilizador no WEBSITE e permitir a fruição das funcionalidades da mesma.')}}</td>
                      <td>{{$t('Nome e email.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para manter o seu registo e dados de utilizador na área reservada.')}}</td>
                      <td>{{$t('Nome e email.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para as operações de gestão do WEBSITE.')}}</td>
                      <td>{{$t('Dados de cookies.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para fins comerciais, como análise de dados, auditorias.')}}</td>
                      <td>{{$t('Dados de cookies.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para prevenção de fraudes e segurança dos sistemas de informação.')}}</td>
                      <td>{{$t('Endereço IP; Dados de cookies.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para a adaptação, melhoria e modificação dos serviços, nomeadamente, através da identificação de tendências de utilização, ou, para determinar a eficácia das campanhas promocionais.')}}</td>
                      <td>{{$t('Dados de cookies.')}}</td>
                  </tr>
              </tbody>
            </table>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('COMO RECOLHEMOS OS SEUS DADOS PESSOAIS?')}}
              </p>
            </div>

            <p>
              {{$t('Vamos recolher os seus dados pessoais através dos formulários presentes no WEBSITE, mas igualmente através do WEBSITE e da comunicação que este faz com o seu equipamento e mensagens de e-mail que nos envia.')}}
            </p>
            <p>
              {{$t('Os seus dados pessoais são recolhidos através do seu equipamento da seguinte forma:')}}
            </p>

            <ol type="a">
              <li>{{$t('Através do seu navegador;')}}</li>
              <li>{{$t('Através de cookies;')}}</li>
              <li>{{$t('Através de pixel tags e outras tecnologias semelhantes;')}}</li>
              <li>{{$t('Endereço IP;')}}</li>
              <li>{{$t('Através dos seus dados de Utilizador.')}}</li>
            </ol>

            <p>
              {{$t('A CONSTÁLICA assume o compromisso de tratar os seus dados conforme a lei e de forma legítima.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA não irá vender, nem alugar ou partilhar os seus dados pessoais com terceiros, exceto nos casos claramente identificados nesta Política de Privacidade.')}}
            </p>
            <p>
              {{$t('Os serviços da CONSTÁLICA não são dirigidos a menores, não sendo tratados dados pessoais de menores de forma intencional.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('O QUE SÃO COOKIES?')}}
              </p>
            </div>

            <p>
              {{$t('Cookies são pequenos arquivos de informações que ajudam a identificar o seu browser e que podem armazenar informações, por exemplo, configurações e preferências do Utilizador.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA irá armazenar cookies no seu equipamento para personalizar e facilitar ao máximo a navegação, mas também, para a solução de problemas, estatísticas, garantia de qualidade, e para monitorar a segurança do sistema.')}}
            </p>
            <p>
              {{$t('Com exceção dos cookies especificamente necessários ao desempenho do website, o armazenamento de outros cookies dependerá sempre da aceitação e consentimento do Utilizador, podendo esse consentimento ser retirado a todo o tempo através de ferramentas específicas do browser.')}}
            </p>
            <p>
              {{$t('Para saber mais sobre os cookies que utilizamos deve consultar a nossa Política de Cookies.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('O QUE SÃO PIXEL TAGS E OUTRAS TECNOLOGIAS SEMELHANTES?')}}
              </p>
            </div>

            <p>
              {{$t('Os pixel tags (também conhecidos como web beacons e clear GIFs) podem ser usados em conexão com alguns serviços para, por exemplo, acompanhar as ações dos utilizadores dos serviços (incluindo destinatários de email), medir o sucesso das nossas campanhas de marketing e compilar estatísticas sobre a utilização dos Serviços e taxas de resposta.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('COMO PROTEGEMOS OS SEUS DADOS PESSOAIS?')}}
              </p>
            </div>

            <p>
              {{$t('Os seus dados pessoais são mantidos em segurança através da adoção de diversas medidas de segurança, de caráter técnico e organizativo que garantem que só têm acesso aos dados pessoais os Colaboradores que devem aceder aos mesmos, conforme regras criadas para o efeito.')}}
            </p>
            <p>
              {{$t('Para proteger os seus dados pessoais só recorremos a fornecedores de centros de dados que nos ofereçam medidas de segurança adequadas e documentadas, nomeadamente, garantias que os seus dados pessoais são armazenados em servidores que são mantidos em ambientes controlados com acessos limitados.')}}
            </p>
            <p>
              {{$t('Os dados pessoais são mantidos em servidores seguros junto da CONSTÁLICA, com garantias de segurança adequadas à proteção dos dados pessoais contra a sua difusão, perda, uso indevido, alteração, tratamento ou acesso não autorizado bem como, contra qualquer outra forma de tratamento ilícito.')}}
            </p>
            <p>
              {{$t('Embora tomemos os cuidados e as precauções que entendemos adequadas para proteger os dados pessoais que nos fornece e recolhemos, é preciso ter consciência que nenhum sistema de segurança é impenetrável.')}}
            </p>
            <p>
              {{$t('Assim, deve ter determinados cuidados, como por exemplo, deve manter a sua palavra-chave secreta e não a divulgar a qualquer outra pessoa; caso acredite que a sua palavra-chave foi utilizada indevidamente, deve avisar-nos de imediato; deve também ter o cuidado de iniciar e terminar a sessão sempre que fecha o navegador.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('QUANTO TEMPO CONSERVAMOS OS SEUS DADOS PESSOAIS?')}}
              </p>
            </div>

            <p>
              {{$t('Os seus dados pessoais serão conservados pelo tempo necessário às finalidades a que se destinam, conforme elencado nesta Política de Privacidade. Assim:')}}
            </p>

            <table class="table">
              <thead>
                  <tr>
                      <th>{{$t('FINALIDADE')}}</th>
                      <th>{{$t('TEMPO MÁXIMO')}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>{{$t('Para seleção e recrutamento;')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para analisar e responder às suas mensagens, apoio ao cliente e pedidos de informação.')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para manter um registo dos seus detalhes de contacto.')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para criar a sua conta de utilizador no WEBSITE e permitir a fruição das funcionalidades da mesma.')}}</td>
                      <td>{{$t('Pelo período em que estiver registado como cliente e pretender usufruir dos respetivos serviços do WEBSITE.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para manter o seu registo e dados de utilizador na área reservada.')}}</td>
                      <td>{{$t('Pelo período em que estiver registado como cliente e pretender usufruir dos respetivos serviços do WEBSITE.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para as operações de gestão do WEBSITE.')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para fins comerciais, como análise de dados, auditorias.')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para prevenção de fraudes e segurança dos sistemas de informação.')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
                  <tr>
                      <td>{{$t('Para a adaptação, melhoria e modificação dos serviços, nomeadamente, através da identificação de tendências de utilização, ou, para determinar a eficácia das campanhas promocionais.')}}</td>
                      <td>{{$t('2 anos.')}}</td>
                  </tr>
              </tbody>
            </table>

            <p>
              {{$t('Caso resulte da lei algum período específico ou obrigatório, o período de conservação dos dados será esse. Em todos os outros casos, os dados pessoais serão conservados no máximo durante os tempos acima indicados, períodos que a CONSTÁLICA entende como suficiente para cumprimento das finalidades.')}}
            </p>
            <p>
              {{$t('Findo o período de conservação, todos os dados pessoais recolhidos serão eliminados.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('COMO PODE EXERCER OS SEUS DIREITOS:')}}
              </p>
            </div>

            <p>
              {{$t('Antes de explicarmos como pode exercer os seus direitos, convém saber quais são. Assim, a legislação atribui-lhe o direito de nos solicitar o exercício dos seguintes direitos:')}}
            </p>

            <ol type="a">
              <li>{{$t('Acesso: direito de obter a confirmação de que os dados pessoais que lhe digam respeito são ou não objeto de tratamento e, se for esse o caso, o direito de aceder aos seus dados pessoais;')}}</li>
              <li>{{$t('Retificação: o direito de obter a retificação dos dados pessoais inexatos que lhe digam respeito e a que os seus dados pessoais incompletos sejam completados;')}}</li>
              <li>{{$t('Apagamento: o direito de obter o apagamento dos seus dados pessoais quando se aplique um dos motivos elencados na legislação;')}}</li>
              <li>{{$t('Limitação do tratamento: o direito de obter a limitação do tratamento se se aplicar uma das situações elencadas na legislação;')}}</li>
              <li>{{$t('Oposição: o direito de se opor a qualquer momento ao tratamento dos dados pessoais que lhe digam respeito;')}}</li>
              <li>{{$t('Portabilidade: o direito de receber os dados pessoais que lhe digam respeito num formato estruturado, de uso corrente e de leitura automática.')}}</li>
            </ol>

            <p>
              {{$t('Tem ainda o direito de apresentar reclamação junto à autoridade de controlo competente (em Portugal, a Comissão Nacional de Proteção de Dados em www.cnpd.pt)')}}
            </p>
            <p>
              {{$t('Para efeito do exercício dos direitos acima indicados deverá contactar a CONSTÁLICA através do email maxbox@constalica.com.')}}
            </p>
            <p>
              {{$t('Caso nos solicite a eliminação de alguns dos seus dados pessoais ou da sua totalidade, alguns dos serviços solicitados poderão não lhe ser prestados e a CONSTÁLICA irá conservar apenas os dados pessoais necessários para o cumprimento das obrigações legais a que se encontra vinculada.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('QUANDO COMUNICAMOS DADOS A TERCEIROS?')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA poderá recorrer a terceiros para a prestação de determinados serviços, a nível de manutenção, apoio técnico, marketing, faturação ou gestão de pagamentos, gestão de reservas, podendo estes ter acesso a alguns dos dados pessoais, nomeadamente, os dados necessários para os fins contratualizados.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA assegura que as entidades que tenham acesso aos dados são credíveis e oferecem elevadas garantias de proteção, nunca lhes sendo transmitidos dados para além do necessário à prestação do serviço contratado, permanecendo, contudo, a CONSTÁLICA como responsável pelos dados pessoais disponibilizados.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA poderá ainda comunicar os seus dados às Empresas do grupo empresarial ao qual pertence e com que tenha parcerias comerciais para a criação e oferta de benefícios.')}}
            </p>
            <p>
              {{$t('A CONSTÁLICA poderá ainda transmitir dados a terceiros no âmbito de investigações, inquéritos e processos judiciais e/ou administrativos ou de natureza semelhante, desde que para tal seja devidamente ordenada por ordem judicial nesse sentido.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('WEBSITES DE TERCEIROS.')}}
              </p>
            </div>

            <p>
              {{$t('O WEBSITE poderá conter ligações para outros websites os quais poderão recolher tratar os seus dados pessoais e, esse tratamento é da exclusiva responsabilidade dos proprietários desses websites, não tendo a CONSTÁLICA qualquer responsabilidade pelas suas políticas e/ou práticas.')}}
            </p>
            <p>
              {{$t('Exemplo desses terceiros são o Facebook, Linkedin, Instagram e Youtube através dos botões que estão presentes no WEBSITE.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('TRANSFERÊNCIAS DE DADOS PARA FORA DA UNIÃO EUROPEIA.')}}
              </p>
            </div>

            <p>
              {{$t('Caso possam ocorrer transferências de dados para países terceiros que não pertencendo à União Europeia, a CONSTÁLICA cumprirá com as regras legais, nomeadamente no que respeita à adequabilidade do país de destino relativamente à proteção de dados pessoais e aos requisitos, que são aplicáveis a estas transferências, não sendo transferidos dados pessoais para jurisdições que não ofereçam garantias de segurança e proteção.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('OS MENORES.')}}
              </p>
            </div>

            <p>
              {{$t('O WEBSITE não é dirigido a menores de 18 anos, pelo que solicitamos que estes menores não nos forneçam dados pessoais através do WEBSITE, aplicação, redes sociais e social media ou emails.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('DADOS PESSOAIS SENSÍVEIS.')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA agradece que não nos envie nem nos dê a conhecer quaisquer dados pessoais sensíveis, ou seja, informações que revelem a origem racial ou étnica, opiniões políticas, crenças religiosas ou filosóficas, associação sindical, informações genéticas, informações biométricas, dados relativos à saúde ou dados relativos a vida sexual de uma pessoa natural ou a orientação sexual.')}}
            </p>
            <p>
              {{$t('Caso ainda assim nos envie ou dê a conhecer essas categorias de dados pessoais, estes serão imediatamente apagados.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('ALTERAÇÕES À POLÍTICA DE PRIVACIDADE.')}}
              </p>
            </div>

            <p>
              {{$t('A CONSTÁLICA reserva-se no direito de reajustar ou alterar a presente Política de Privacidade, a qualquer momento, sendo essas alterações publicitadas.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('OS NOSSOS DETALHES DE CONTACTO.')}}
              </p>
            </div>

            <p>
              {{$t('Caso tenha alguma dúvida ou questão relacionada com esta Política de Privacidade por favor contacte-nos por escrito através do email maxbox@constalica.com.')}}
            </p>

            <div class="page_section__header">
              <p class="page_section__title t-h--2">
                {{$t('ÚLTIMA VERSÃO')}}.
              </p>
            </div>

            <p>
              12 07, 2021. Vouzela (Portugal)
            </p>
            
        </template>
    </LayoutMain>
</template>

<script>
import LayoutMain from "../layouts/l-main.vue";

export default {

  components: {
    LayoutMain,
  },
  data() {
    return {
    };
  },
  computed: {
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped>
p {
  padding:10px 50px;
}

ol {
  padding-left: 100px;
}

td {
  width:50%;
}

.page_section__title{
  font-size: 20px !important;
  padding:30px 20px 10px 20px;
}

.page_section {
  position: relative;

  &:not(:last-child) {
    margin-bottom: 32px;
  }

  &__header {
    padding: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #d0d0d0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__body {
    padding: 8px;
  }
}
</style>
